import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwButtonConfig, DwCardBaseComponent, DwComponent, DwComponentType, DwMediaEntity, DwMediaRepositoryService, DwMediaSelectOptions, DwMenuActionType, DwMetaDataListCardConfigData, DwMetaDataRoutingService, DwModalConfig, DwModalService, DwRoutingService, isAfterDate } from '@devwareapps/devware-cap';
import { finalize, mergeMap, take } from 'rxjs/operators';
import {
  AcsWrittenTestStatusAllItems,
  AppMetaDataItemNames,
  CourseEntity,
  CourseListForStudentMarketplaceQueryEntity,
  CourseListForStudentQueryEntity
} from '../../../../../meta-data/app-meta-data.service';
import { CourseNavigationService } from '../../../services/course-navigation.service';
import { PaymentPurchaseService } from '../../../../payments/services/payments-purchase.service';
import { PaymentParty } from '../../../../payments/models/payment-party.enum';
import { ACSSubmissionUtilService } from '../../../../students/services/acs-submission-util.service';
import { CourseRepositoryService } from '../../../services/course-repository.service';
import { SchoolRepositoryService } from '../../../../schools/services/school-repository.service';
import { UnlimitedCourseAccessService } from '../../../services/unlimited-course-access.service';

@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Course Card',
  key: 'courseCard',
  componentType: DwComponentType.card,
  //configComponent: DwCardDefaultConfigComponent,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.Course,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})
@Component({
  selector: 'app-course-card',
  templateUrl: './course-card.component.html',
  styleUrls: ['./course-card.component.scss']
})
export class CourseCardComponent implements DwCardBaseComponent<any, CourseEntity> {
  cardConfig?: any;
  data?: CourseListForStudentQueryEntity;
  allowedFileTypes: string = '.pdf,.jpg,.jpeg,.png';

  data2?: CourseListForStudentMarketplaceQueryEntity;
  resolvedContext?: any;
  cardClick: EventEmitter<any> = new EventEmitter<any>();

  buttonConfig: DwButtonConfig = {
    buttonText: 'Written Upload',
    buttonClass: 'btn btn-primary',
    //iconClass: 'fa fa-upload dw-icon-grid dw-green',
  }

  courseImageUrl: string = '/assets/aviator-online/img/course-image-default.png';
  progressPercent = 25;
  ignoreClick: boolean;
  endorsed: boolean;
  expired: boolean;
  availableForPurchase: boolean = false;
  uploading: boolean = false;
  processing: boolean = false;
  notificationLoading = false;
  notificationRequested = false;
  comingSoon = false;
  canRequestAvailabilityNotification = false;
  marketplaceActionLabel = 'Purchase';

  hideSubmitACS: boolean = false;
  constructor(private dwMediaRepository: DwMediaRepositoryService,
    private courseNavigationService: CourseNavigationService,
    private dwMetaDataRoutingService: DwMetaDataRoutingService,
    private paymentsPurchaseService: PaymentPurchaseService,
    private acsSubmissionUtilService: ACSSubmissionUtilService,
    private dwModalService: DwModalService,
    private courseRepositoryService: CourseRepositoryService,
    private schoolRepositoryService: SchoolRepositoryService,
    private unlimitedCourseAccessService: UnlimitedCourseAccessService

  ) { }

  setupCard() {

    this.progressPercent = this.data?.StudentCoursePercentComplete || 0;

    this.courseImageUrl = this.dwMediaRepository.getImageUrlFromMediaPath(this.data.MediaMediaPath, 350, 250);

    this.data2 = this.data as CourseListForStudentMarketplaceQueryEntity;
    this.comingSoon = !!this.data2.ComingSoon;
    this.canRequestAvailabilityNotification = this.comingSoon;

    if (!this.data.StudentCourseIsEndorsed) {
      this.hideSubmitACS = true;
    }

    if (this.data.AcsTestResultsPassedAny) {
      this.hideSubmitACS = true;
    }

    if (this.data.AcsTestResultsFailedAny) {
      this.buttonConfig.buttonText = 'Resubmit Written';
    }

    if (this.data2.RoStudentSchoolCoursesCourseId) {
      this.availableForPurchase = !this.data2.RoStudentSchoolCoursesStudentCourseId;
    }

    if (this.canRequestAvailabilityNotification) {
      this.courseRepositoryService.getCourseAvailabilityNotifications()
        .pipe(take(1))
        .subscribe(notifications => {
          this.notificationRequested = notifications.some(item => item.CourseId === this.data.CourseId && item.IsActive);
        });
    }

    if (this.data?.StudentCourseIsEndorsed) {
      this.endorsed = true;
      this.progressPercent = 100;

      if (isAfterDate(this.data?.CourseEndorsementStudentExpirationDateTime)) {
        this.expired = true;
      }
    }

  }

  click() {


    if (this.ignoreClick) {
      setTimeout(() => {
        this.ignoreClick = false;
      }, 500)
      return;
    }

    if (this.availableForPurchase && !this.comingSoon) {
      this.purchaseCourse();
      return;
    }

    if (this.comingSoon) {
      return;
    }

    this.courseNavigationService.navigateToCourse(this.data.CourseId);

    // Do the same this for expired courses
    // if (this.expired) {
    //   this.viewEndorsement();
    //   return;
    // }

    //this.cardClick.emit(this.data);
  }

  purchaseCourse() {

    const marketplaceData = this.data as CourseListForStudentMarketplaceQueryEntity;
    const modalConfig = {
      productId: marketplaceData.ProductProductId,
      courseId: this.data.CourseId,
      paymentParty: PaymentParty.Student,
      paymentMethodId: undefined
    };
    this.paymentsPurchaseService.showPurchaseCourseModal(modalConfig)
      .subscribe(result => {
        // Might not need to do anything here if an event is published to refresh the course list
      });
  }

  resume() {
    this.ignoreClick = true;

    if (this.data.NextCourseLessonCourseLessonId && this.data.CourseModuleCourseModuleId) {
      this.courseNavigationService.navigateToLesson({
        courseId: this.data.CourseId,
        moduleId: this.data.CourseModuleCourseModuleId,
        lessonId: this.data.NextCourseLessonCourseLessonId
      });
      return;
    }

    this.courseNavigationService.resumeCourse(this.data.CourseId);
  }

  viewEndorsement() {
    this.ignoreClick = true;
    // this.click();
    const endorsementStudentId = this.data.CourseEndorsementStudentCourseEndorsementStudentId;

    const modalOptions: Partial<DwModalConfig> = {
      title: 'View Endorsement',
    }

    return this.dwMetaDataRoutingService.openAddEditViewModal(DwMenuActionType.view, AppMetaDataItemNames.CourseEndorsementStudent, endorsementStudentId, null, null, 'student-view', modalOptions, true)
      .subscribe(modalResult => {
      });
  }

  ngOnInit(): void {
    this.schoolRepositoryService.getSchoolFeatures()
      .pipe(
        take(1),
        mergeMap(schoolFeatures => this.unlimitedCourseAccessService.hasAccess(schoolFeatures))
      )
      .subscribe(hasAccess => {
        this.marketplaceActionLabel = hasAccess ? 'Access' : 'Purchase';
      });
  }

  submitACS(event: MouseEvent, fileSingle: HTMLInputElement) {
    this.ignoreClick = true;

    fileSingle.click();
  }


  selectFiles(files: FileList, fileControl: any = null) {
    this.uploading = true;

    this.acsSubmissionUtilService.showSelectFilesModal(files, fileControl)
      .pipe(finalize(() => {
        this.uploading = false;
        if (fileControl) {
          fileControl.value = '';
        }
      }))
      .subscribe((result) => {
        if (result) {
          this.handleFileSelectResult(result);
        }
      });
  }

  setAvailabilityNotification(event: MouseEvent, isActive: boolean) {
    event.stopPropagation();

    if (this.notificationLoading) {
      return;
    }

    this.notificationLoading = true;
    this.courseRepositoryService.setCourseAvailabilityNotification(this.data.CourseId, isActive)
      .pipe(finalize(() => this.notificationLoading = false))
      .subscribe(() => this.notificationRequested = isActive);
  }

  handleFileSelectResult(media: DwMediaEntity) {
    // Save the ACS Written Result
    this.processing = true;
    this.acsSubmissionUtilService.processACSTestFile(media, this.data?.StudentCourseStudentCourseId, this.data?.AcsTestId)
      .pipe(finalize(() => {
        this.processing = false;
      }))
      .subscribe((acsWrittenResult) => {
        if (acsWrittenResult.AcsWrittenTestStatusId == AcsWrittenTestStatusAllItems.FailedInvalid) {
          // don't redirect 
          return;
        }

        this.click();
      });
  }


}
